import { useLang } from "@/lib/LanguageContext";
import { studioContact } from "@/lib/portfolio";

const sitemap = [
    { id: "home", key: "home" },
    { id: "about", key: "about" },
    { id: "work", key: "work" },
    { id: "offer", key: "offer" },
    { id: "contact", key: "contact" },
];

export default function Footer() {
    const { t, lang, setLang } = useLang();
    const year = new Date().getFullYear();

    const scrollTo = (id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <footer
            data-testid="site-footer"
            className="bg-navy text-ivory pt-20 pb-10"
        >
            <div className="mx-auto max-w-screen-2xl px-6 md:px-12 lg:px-20">
                <div className="grid grid-cols-2 gap-8 md:grid-cols-12 md:gap-16 border-b border-ivory/15 pb-16">
                    <div className="col-span-2 md:col-span-5">
                        <img
                            src="https://customer-assets.emergentagent.com/job_color-walls-2/artifacts/h6cx2bzz_Picsart_26-06-24_22-19-59-878.png"
                            alt="Ahmetography — Wall art & Crafts"
                            data-testid="footer-logo-image"
                            className="h-40 md:h-48 w-auto -ml-3"
                            style={{ mixBlendMode: "lighten" }}
                        />
                        <p className="mt-6 max-w-sm text-ivory/65 leading-relaxed">
                            {t.contact.cta}
                        </p>
                    </div>

                    <div className="col-span-1 md:col-span-2">
                        <p className="overline text-ivory/45 mb-5">
                            {t.footer.sitemap}
                        </p>
                        <ul className="space-y-3">
                            {sitemap.map((s) => (
                                <li key={s.id}>
                                    <button
                                        type="button"
                                        onClick={() => scrollTo(s.id)}
                                        data-testid={`footer-nav-${s.id}`}
                                        className="text-ivory/85 hover:text-terracotta transition-colors"
                                    >
                                        {t.nav[s.key]}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="col-span-1 md:col-span-2">
                        <p className="overline text-ivory/45 mb-5">
                            {t.footer.studio}
                        </p>
                        <p className="text-ivory/85">{t.footer.location}</p>
                        <a
                            href={`mailto:${studioContact.email}`}
                            className="block mt-3 text-ivory/85 hover:text-terracotta transition-colors break-all"
                            data-testid="footer-email"
                        >
                            {studioContact.email}
                        </a>
                    </div>

                    <div className="col-span-2 md:col-span-3">
                        <p className="overline text-ivory/45 mb-5">
                            {t.footer.social}
                        </p>
                        <ul className="space-y-3">
                            <li>
                                <a
                                    href={studioContact.instagramLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-ivory/85 hover:text-terracotta transition-colors"
                                    data-testid="footer-instagram"
                                >
                                    Instagram — {studioContact.instagram}
                                </a>
                            </li>
                            <li>
                                <a
                                    href={studioContact.whatsappLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-ivory/85 hover:text-terracotta transition-colors"
                                    data-testid="footer-whatsapp"
                                >
                                    WhatsApp — {studioContact.whatsapp}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mt-10 overline text-ivory/55">
                    <p>
                        © {year} {t.brand.name} · {t.footer.rights}
                    </p>
                    <p className="italic font-serif text-base text-ivory/65 normal-case tracking-normal">
                        {t.footer.credit}
                    </p>
                    <div className="flex items-center gap-3">
                        <button
                            type="button"
                            data-testid="footer-lang-en"
                            onClick={() => setLang("en")}
                            className={
                                lang === "en"
                                    ? "text-terracotta"
                                    : "text-ivory/55 hover:text-ivory"
                            }
                        >
                            EN
                        </button>
                        <span className="text-ivory/30">/</span>
                        <button
                            type="button"
                            data-testid="footer-lang-tr"
                            onClick={() => setLang("tr")}
                            className={
                                lang === "tr"
                                    ? "text-terracotta"
                                    : "text-ivory/55 hover:text-ivory"
                            }
                        >
                            TR
                        </button>
                        <span className="text-ivory/30">/</span>
                        <button
                            type="button"
                            data-testid="footer-lang-nl"
                            onClick={() => setLang("nl")}
                            className={
                                lang === "nl"
                                    ? "text-terracotta"
                                    : "text-ivory/55 hover:text-ivory"
                            }
                        >
                            NL
                        </button>
                    </div>
                </div>
            </div>
        </footer>
    );
}
